__turbopack_context__.v({
  "AlignRight": "k3A98G_AlignRight",
  "ChartHeader": "k3A98G_ChartHeader",
  "DynamicPropertyContainer": "k3A98G_DynamicPropertyContainer",
  "Image": "k3A98G_Image",
  "ImageNoAspect": "k3A98G_ImageNoAspect",
  "ImageNoCover": "k3A98G_ImageNoCover",
  "Root": "k3A98G_Root",
  "ThreeImages": "k3A98G_ThreeImages",
  "Title": "k3A98G_Title",
  "Title--Large": "k3A98G_Title--Large",
  "TwoImages": "k3A98G_TwoImages",
  "skeleton-loading": "k3A98G_skeleton-loading",
});
